interface Config {
  API: string;
}

const Config = {
  DOCUMENT_TITLE: 'DREAMLINK',
  APP_URL: process.env.REACT_APP_APP_URL || `${window.location.origin}`,
  API: process.env.REACT_APP_API_URL || `${window.location.origin}/api`,
};

export default Config;
